import { useCallback, useMemo, useState } from "react";
import CollectionsBookmarkOutlinedIcon from "@mui/icons-material/CollectionsBookmarkOutlined";
import { useStorage } from "@platform/hooks";
import { Alert } from "@platform/design-system";

const STORAGE_KEY_PREFIX = "benchmark-banner-dismissed";

interface BenchmarkBannerProps {
  rfpId: string;
  coverageType: string;
}

export function BenchmarkBanner({
  rfpId,
  coverageType,
}: BenchmarkBannerProps): React.ReactElement | null {
  const { getStorageItem, setStorageItem } = useStorage("local");
  const storageKey = `${STORAGE_KEY_PREFIX}:${rfpId}:${coverageType}`;

  // Re-read localStorage whenever the key changes (LOC switch)
  const storedDismissed = useMemo(
    () => getStorageItem<boolean>(storageKey) === true,
    [getStorageItem, storageKey],
  );

  // Local state tracks in-session dismissal; resets when key changes
  const [dismissedKey, setDismissedKey] = useState<string | null>(null);
  const dismissed = storedDismissed || dismissedKey === storageKey;

  const handleDismiss = useCallback((): void => {
    setStorageItem(storageKey, true);
    setDismissedKey(storageKey);
  }, [setStorageItem, storageKey]);

  if (dismissed) return null;

  return (
    <Alert
      severity="info"
      variant="outlined"
      icon={<CollectionsBookmarkOutlinedIcon fontSize="small" />}
      onClose={handleDismiss}
    >
      This data has been populated through Centro Benchmark Plan Design
    </Alert>
  );
}
